import { i18n } from 'vue-infra';
import { METRIC_NAMES } from '@config/Consts';

function makeCSATReason(options) {
  const { condition, value, agentName } = options;
  const metricName = i18n.t('amd:metric_csat');
  const agent = i18n.t('amd:agent_name', { agentName });
  const reason = i18n.t(`amd:metric_alert_${condition}`, { metricName, value },
  );
  return {
    general: reason,
    personal: `${agent} ${reason}`,
    metricName,
  };
}

function makeAgentLoadReason(options) {
  const { condition, value, agentName } = options;
  const metricName = i18n.t('amd:metric_load');
  const agent = i18n.t('amd:agent_name', { agentName });
  const reason = i18n.t(`amd:metric_alert_${condition}`, { metricName, value },
  );
  return {
    general: reason,
    personal: `${agent} ${reason}`,
    metricName,
  };
}
function makeTransferRateReason(options) {
  const { condition, value, agentName } = options;
  const metricName = i18n.t('amd:metric_transfer_rate');
  const agent = i18n.t('amd:agent_name', { agentName });
  const reason = i18n.t(`amd:metric_alert_${condition}`, { metricName, value },
  );
  return {
    general: reason,
    personal: `${agent} ${reason}`,
    metricName,
  };
}

function makeAgentStatusDurationReason(options) {
  const { agentName, agentStatus, condition, threshHold } = options;
  return {
    general: i18n.t(
      'amd:agent_alert_notification',
      { agentName: '', agentStatus, condition, threshHold },
    ),
    personal: i18n.t(
      'amd:agent_alert_notification',
      { agentName, agentStatus, condition, threshHold },
    ),
    metricName: i18n.t('amd:metric_agent_status_duration'),
  };
}

export const i18nHandlers = {
  [METRIC_NAMES.AGENT_VIEW_CSAT]: makeCSATReason,
  [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION]: makeAgentStatusDurationReason,
  [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS]: () => {},
  [METRIC_NAMES.AGENT_VIEW_AGENT_LOAD]: makeAgentLoadReason,
  [METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE]: makeTransferRateReason,

};
